"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var fee_detail_controller_1 = __importDefault(require("./fee-detail.controller"));
var fee_detail_html_1 = __importDefault(require("./fee-detail.html"));
function FeeDetail() {
    return {
        restrict: "E",
        scope: {
            fee: "=",
            payments: "=",
        },
        template: fee_detail_html_1.default,
        controller: fee_detail_controller_1.default,
        controllerAs: "vm",
        bindToController: true,
    };
}
exports.default = angular_1.default
    .module("directives.feedetail", [])
    .directive("feeDetail", FeeDetail)
    .controller("FeeDetailController", fee_detail_controller_1.default);
